<script>
  import { onMount, onDestroy } from "svelte"
  import { fade, fly } from "svelte/transition"
  import { tick } from "svelte"
  import { initialized, me, session, master, update } from "../store"
  import VotingScreen from "./VotingScreen.svelte"
  import RoundWinScreen from "./RoundWinScreen.svelte"
  import SubmitScreen from "./SubmitScreen.svelte"
  import play from "../lib/play"
  import FinalScreen from "./FinalScreen.svelte"
  import WaitScreen from "./WaitScreen.svelte"

  let onSentence = null
  let onPhase = null
  let watching = false
  let nextPhaseTime = 0
  let blanks = []
  let sentences = []
  let timo = 0
  let submissions = {}
  let lastSubmissionCount = -1
  $: {
    if ($session) {
      onSentence = $session.onSentence
      onPhase = $session.onPhase
      blanks = $session.blanks
      nextPhaseTime = $session.nextPhase

      sentences = $session.sentences
      submissions =
        $session.submissions &&
        onSentence !== null &&
        $session.submissions[onSentence]
          ? $session.submissions[onSentence]
          : {}
      const subValues = Object.values(submissions)
      if (subValues.length > lastSubmissionCount) {
        if (lastSubmissionCount > -1) play("pop")
        lastSubmissionCount = subValues.length
      }
      if ($master) {
        if (onPhase === 0 && subValues.length >= $session.maxPerRound) {
          nextPhase()
        }
        if (!watching && $master) {
          watching = true
          setInterval(async () => {
            const now = +new Date()
            if (!["final", "waiting"].includes($session.onStatus)) {
              if (nextPhaseTime === 0) {
                nextPhase()
              } else {
                update("nextPhase", nextPhaseTime - 1)
              }
            }
          }, 900)
        }
      }
    }
  }
  function nextPhase() {
    let next = onPhase + 1
    let nextPhaseDiff = $session.submitTime || 25

    // If we are out of sentences, it's over
    if (
      sentences.length > 0 &&
      (next > 2 && onSentence + 1 >= sentences.length)
    ) {
      update("onStatus", "final")
    } else {
      if (next === 1) {
        nextPhaseDiff = $session.voteTime || 25
        update("allowSubmit", false)
      } else if (next === 2) {
        nextPhaseDiff = $session.reviewTime || 15
      } else if (next > 2) {
        next = 0
        update("onSentence", onSentence + 1)
      }
      update("onPhase", next)
      update("nextPhase", nextPhaseDiff)
    }
  }
</script>

<style lang="scss">
  @import "../vars";
  h1 {
    padding: 0.5rem 2rem;
    margin: 0;
    font-family: Produkt;
    color: $green;
  }
  :global(h2) {
    color: d($gray, 30%) !important;
  }
  .content {
    padding: 2rem;
    @include below(bigphone) {
      padding: 1rem;
    }
  }
  .shell {
    display: grid;
    width: 48rem;
    margin: 6rem auto 0;
    position: relative;
    @include below(tablet) {
      width: 100%;
      margin-top: 4rem;
    }
    @include below(bigphone) {
      width: 100%;
      margin-top: 1rem;
    }
    @media (max-height: 1100px) {
      margin-top: 3rem;
    }
    @media (max-height: 900px) {
      margin-top: 1rem;
    }
  }
  .animated {
    grid-area: 1 / 1 / 1 / 1;
    margin: 0 auto;
    width: 100%;
  }
  .masterControls {
    margin-top: 7rem;
    button {
      display: block;
      background: $green;
      color: $white;
      border: 0;
      padding: 1rem;
      min-width: 8rem;
      cursor: pointer;
    }
  }
</style>

<div class="shell">
  {#if $session.onStatus === 'waiting' || $session.onStatus === 'starting'}
    <div in:fade out:fly={{ x: 200, duration: 300 }} class="animated">
      <WaitScreen />
    </div>
  {:else if $session.onStatus === 'final'}
    <div in:fade class="animated">
      <FinalScreen />
    </div>
  {:else if $session.onStatus === 'playing' && sentences.length}
    {#if onPhase === 0}
      <div
        in:fly={{ x: -200, duration: 300 }}
        out:fly={{ x: 200, duration: 300 }}
        class="animated">
        <SubmitScreen sentence={sentences[onSentence]} {blanks} />
      </div>
    {:else if onPhase === 1}
      <div
        in:fly={{ x: -200, duration: 300 }}
        out:fly={{ x: 200, duration: 300 }}
        class="animated">
        <VotingScreen sentence={sentences[onSentence]} {blanks} {submissions} />
      </div>
    {:else if onPhase === 2}
      <div
        in:fly={{ x: -200, duration: 300 }}
        out:fly={{ x: 200, duration: 300 }}
        class="animated">
        <RoundWinScreen sentence={sentences[onSentence]} {blanks} />
      </div>
    {/if}
  {/if}
  {#if $master}
    <div class="masterControls">
      {#if $session.onStatus === 'waiting'}
        <button on:click={() => update('onStatus', 'starting')}>Start</button>
      {/if}
      {#if $session.onStatus === 'playing' && $session.onPhase === 0}
        <button on:click={() => update('allowSubmit', true)}>
          Allow Submit
        </button>
      {/if}
    </div>
  {/if}
</div>
